<template>
  <div class="header">
    <a-row>
      <a-col :span="6">
        <img class="img-logo"
             :src="company.companyLogo"
             :alt="company.companyName">
      </a-col>
      <a-col :span="10">
        <div class="flex-row-center">
          <div class="nav-top-center flex-column-center"
               v-for="(item, index) in list"
               :key="index"
               @click="navTo(item, index)">
            <span :class="[selectIndex == index? 'select':'']">{{item.name}}</span>
            <span v-if="selectIndex == index"
                  class="line"></span>
          </div>
        </div>
      </a-col>
      <a-col :span="8">
        <img class="head"
             :src="logo"
             v-if="isLogin"
             @error="headError"
             alt="">
        <span class="head-name"
              v-if="isLogin">{{headName}}</span>
        <a-button class="login"
                  v-if="!isLogin"
                  @click="loginModelShow">登录</a-button>
        <a-button class="login"
                  v-if="isLogin"
                  @click="loginOut">退出</a-button>

        <a-button class="change-password"
                  v-if="isLogin"
                  @click="changePWDShow">
          修改密码
        </a-button>
      </a-col>
    </a-row>

    <a-modal title=""
             :visible="changePsd.visible"
             @cancel="changePsdCancel"
             :centered="true"
             ref="changePwd"
             :footer="null">
      <h3 class="dialogTitle">修改密码</h3>

      <a-form-model layout="horizontal"
                    :model="changePsd.form"
                    @submit="changePsdSubmit"
                    ref="changePwdForm"
                    :rules="changePwdRules"
                    @submit.native.prevent>
        <a-form-model-item prop="oldPwd">
          <a-input v-model="changePsd.form.oldPwd"
                   type="password"
                   placeholder="请输入旧密码"
                   :maxLength="20">
            <a-icon slot="prefix"
                    type="lock"
                    style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item prop="newPwd">
          <a-input v-model="changePsd.form.newPwd"
                   type="password"
                   :maxLength="20"
                   placeholder="请输入新密码">
            <a-icon slot="prefix"
                    type="lock"
                    style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item prop="newConfirmPwd">
          <a-input v-model="changePsd.form.newConfirmPwd"
                   type="password"
                   :maxLength="20"
                   placeholder="请确认新密码">
            <a-icon slot="prefix"
                    type="lock"
                    style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item>
          <a-button class="submit"
                    html-type="submit">
            确认
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <user-index ref="userIndex" @checkLogin="initData()"></user-index>
  </div>
</template>

<script>

import HeaderFooterData from "../../assets/datas/HeaderFooterData.json";
import { companyInfo, changePWD } from "../../assets/api/api";
import UserIndex from "./UserIndex.vue";
export default {
  name: 'Header',
  components:{
    UserIndex
  },
  data () {
    return {
      list: [],
      selectIndex: 0,
      isLogin: false,
      changePsd: {
        visible: false,
        form: {
          oldPwd: '',
          newPwd: '',
          newConfirmPwd: ''
        }
      },
      company: {
        companyName: '',
        companyLogo: ''
      },
      logo: 'http://img.pooway.net.cn/head.png',
      rules: {
        user: [
          { required: true, message: '请输入手机号', trigger: ['change', 'blur'] },
          {
            validator: (rule, value, cbfn) => {
              const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
              if (!reg.test(value)) {
                cbfn('请输入正确的手机号码')
              }
              cbfn()
            }
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: ['change', 'blur'] },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: ['change', 'blur'] },
          {
            validator: (rule, value, cbfn) => {
              const reg = /^[0-9]{6}$/
              if (!reg.test(value)) {
                cbfn('请输入正确的验证码')
              }
              cbfn()
            }
          }
        ]
      },
      changePwdRules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: ['change', 'blur'] },
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: ['change', 'blur'] },
        ],
        newConfirmPwd: [
          { required: true, message: '请确认新密码', trigger: ['change', 'blur'] },
        ]
      },
      headName: '',
    }
  },
  watch: {
    $route (to, from) {
      if (to.path == "/MyCourse") {
        this.selectIndex = 1
      }
    }
  },
  mounted () {
    this.$message.config({
      top: `400px`,
      duration: 2,
      maxCount: 1,
    });
    if (this.$route.path == "/MyCourse") {
      this.selectIndex = 1
    }
    this.fatchData()
    this.initData()
  },
  methods: {
    fatchData () {
      this.list = HeaderFooterData.navList
      this.getCompanyInfo()
    },
    initData () {
      if (localStorage.getItem('phone')) {
        this.isLogin = localStorage.getItem("phone") && localStorage.getItem("phone").length > 0
      }

      if (localStorage.getItem('headImgUrl')) {
        this.logo = localStorage.getItem('headImgUrl')
      } else {
        this.logo = ''
      }

      if (localStorage.getItem('realName')) {
        this.headName = localStorage.getItem('realName')
      } else if (localStorage.getItem('phone')) {
        this.headName = localStorage.getItem('phone')
      } else {
        this.headName = ''
      }
    },
    // 获取公司logo图
    getCompanyInfo () {
      companyInfo({}).then(res => {
        this.company.companyLogo = res.data.companyInfo.companyLogo
        this.company.companyName = res.data.companyInfo.companyName
        this.$store.state.companyPhone = res.data.companyInfo.phone
        document.title = this.company.companyName
      }).catch((err) => {
      }).finally(() => {
      })
    },
    navTo (item, index) {
      if (index == 1 && !localStorage.getItem('userId')) {
        // this.$message.error('您还没有登录，请登录！');
        this.loginModelShow()
        return
      }
      this.selectIndex = index
      this.$router.push({ name: item.router })
    },
    loginModelShow () {
     this.$refs['userIndex'].login.visible = true
    },   
    changePWDShow () {
       this.changePsd.visible = true
    },
    changePsdCancel () {
      this.changePsd.visible = false
      this.changePsd.form = {
        oldPwd: '',
        newPwd: '',
        newConfirmPwd: ""
      }
    },
    changePsdSubmit () {
      this.$refs.changePwdForm.validate(valid => {
        if (valid) {
          if (this.changePsd.form.newPwd !== this.changePsd.form.newConfirmPwd) {
            this.$message.error('两次新密码输入不一致');
            return;
          }
          const params = {
            uId: localStorage.getItem('userId'),
            oldPwd: this.changePsd.form.oldPwd,
            newPwd: this.changePsd.form.newPwd
          }
          changePWD(params).then(res => {
            if (res.flag == '1') {
              this.changePsd.visible = false
              this.$message.success('修改成功！');
              this.changePsd.form = {
                oldPwd: '',
                newPwd: '',
                newConfirmPwd: ""
              }
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err) => {
            //  console.log(err)
          }).finally(() => {
          })
        } else {
          return false;
        }
      });



    },
    loginOut () {
      const this_ = this
      this.$confirm({
        title: '确认退出？',
        content: '您确定要退出吗？',
        okText: '确认',
        cancelText: '取消',
        onOk () {
          this_.isLogin = false
          localStorage.removeItem('phone')
          localStorage.removeItem('headImgUrl')
          localStorage.removeItem('userId')
          localStorage.removeItem('realName')
          this_.selectIndex = 0
          // let backlen = -(window.history.length - 1);
          // this_.$router.go(backlen);
          // console.log(backlen)
          this_.$router.replace({ path: '/Home' });
          location.reload();
        },
        onCancel () { },
      });
    },
    headError (e) {
      e.target.src = require("../../assets/images/default_img.jpg");
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-size: 19px;
  width: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  height: 100%;
  text-align: center;
  .img-logo {
    width: auto;
    height: 42px;
    display: inline-block;
    font-size: 15px;
    line-height: 42px;
    object-fit: cover;
  }

  .nav-top-center {
    width: 140px;
    height: 80px;
    cursor: pointer;
    span {
      line-height: initial;
    }
    .line {
      width: 30px;
      height: 4px;
      background-color: #2d78c5;
    }
    .select {
      font-size: 19px;
      color: #2d78c5;
    }
  }

  .head-name {
    margin-right: 30px;
    font-size: 15px;
    margin-left: 10px;
  }

  .head {
    vertical-align: middle;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .login {
    background-color: #2d78c5;
    border-color: #2d78c5;
    margin-left: 10px;
    // padding: 9px 15px;
    font-size: 12px;
    color: #ffffff;
    border-radius: 5px;
    line-height: normal;
  }

  .login:hover {
    opacity: 0.8;
  }

  .change-password {
    background-color: rgb(103, 194, 58);
    border-color: rgb(103, 194, 58);
    margin-left: 10px;
    // padding: 9px 15px;
    font-size: 12px;
    color: #ffffff;
    border-radius: 5px;
    line-height: normal;
  }

  .change-password:hover {
    opacity: 0.8;
  }
}

/deep/.ant-row,
/deep/.ant-col {
  height: 100%;
  line-height: 80px;
}

</style>

